import { create } from 'zustand';
import { SavedList } from '~/clientApi/savedLists.model';
import { IShareLinkMapped } from '~/shareLinkApi/shareLink.model';
import { ICreator } from '~/types';

type MessageToolStore = {
  isModalOpen: boolean;
  openModal: (props: {
    creator?: ICreator;
    list?: SavedList;
    link?: IShareLinkMapped;
  }) => void;
  closeModal: () => void;

  creator: null | ICreator;
  setCreator: (creator: ICreator) => void;

  list: null | SavedList;
  setList: (list: SavedList) => void;

  link: null | IShareLinkMapped;
  setLink: (link: IShareLinkMapped) => void;

  isLoading: boolean;
  setIsLoading: (step: MessageToolStore['isLoading']) => void;

  step: number;
  setStep: (step: MessageToolStore['step']) => void;

  error: string | null;
  setError: (data: MessageToolStore['error']) => void;

  selectedQuestion: number | null;
  setSelectedQuestion: (question: number | null) => void;
};

export const useMessageToolStore = create<MessageToolStore>((set) => ({
  isModalOpen: false,
  openModal: (props) => set({ isModalOpen: true, ...props }),
  step: 1,
  setStep: (step) => set({ step }),

  creator: null,
  setCreator: (creator) => set({ creator }),

  list: null,
  setList: (list) => set({ list }),

  link: null,
  setLink: (link) => set({ link }),

  error: null,
  setError: (error) => set({ error }),
  isLoading: false,
  setIsLoading: (isLoading) => set({ isLoading }),

  selectedQuestion: null,
  setSelectedQuestion: (question) => set({ selectedQuestion: question }),

  closeModal: () =>
    set({
      isModalOpen: false,
      step: 1,
      isLoading: false,
      creator: null,
      list: null,
      link: null,
      error: null,
      selectedQuestion: null,
    }),
}));
